//```import constants types
import {
  VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD,
  VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT,
  VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE,
  VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT,
  VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE
} from 'Redux/actionTypes';


export const vidfleetConfigurationUploadModeLoadData = (esn, devices, mode) => ({
  type: VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD,
  payload: { esn: esn, devices: devices, mode: mode }
});

export const vidfleetConfigurationUploadModeLoadDataResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT,
  payload: data
});

export const vidfleetConfigurationUploadModeSave = (config, esns, deviceIds, oldConfig, applyScopes, verificationCode) => ({
  type: VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE,
  payload: { config: config, esns: esns, deviceIds: deviceIds, oldConfig: oldConfig, applyScopes: applyScopes, verificationCode: verificationCode }
});

export const vidfleetConfigurationUploadModeSaveResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT,
  payload: data
});

export const vidfleetConfigurationUploadModeHide = () => ({
  type: VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE,
  //payload: accounts
});
